var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UsersApiService } from '@ClientApi/users';
import { AddManagers, SetManagersLoading } from './managersAction';
export const ADD_USERS = 'ADD_USERS';
export const RESET_USERS = 'RESET_USERS';
export const REMOVE_USER = 'REMOVE_USER';
export const SET_USERS_LOADING = 'SET_USERS_LOADING';
export class AddUsers {
    constructor(users) {
        this.users = users;
        this.type = ADD_USERS;
    }
}
export class ResetUsers {
    constructor() {
        this.type = RESET_USERS;
    }
}
export class RemoveUser {
    constructor(user) {
        this.user = user;
        this.type = REMOVE_USER;
    }
}
export class SetUsersLoading {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_USERS_LOADING;
    }
}
export const getAllUsers = (forceReload = false) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    if (!forceReload) {
        const { usersLoading, users } = getState().users;
        if (usersLoading || users.length) {
            return;
        }
    }
    dispatch(new SetUsersLoading(true));
    dispatch(new SetManagersLoading(true));
    const users = yield UsersApiService.getAll();
    const usersWithDisplayNames = users.map((user) => {
        return Object.assign(Object.assign({}, user), { displayName: user.name || user.email });
    });
    const managersWithDisplayNames = usersWithDisplayNames.filter((user) => user.is_active && (user.user_profile.can_manager_approve || user.user_profile.is_admin || user.user_profile.role === 'manager'));
    dispatch(new AddUsers(usersWithDisplayNames));
    dispatch(new AddManagers(managersWithDisplayNames));
    dispatch(new SetUsersLoading(false));
    dispatch(new SetManagersLoading(false));
});
export const refreshUsersIfMissing = (userId) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const user = getState().users.usersById[userId];
    if (!user) {
        dispatch(getAllUsers(true));
    }
});
